import * as React from 'react'

import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import User from '~/client/src/shared/models/User'

import Localization from '../../localization/LocalizationManager'
import { ITag } from '../../models/Tag'
import UsersDirectory from '../UsersDirectory/UsersDirectory'

interface IProps {
  appliedUsers: User[]
  onApply: (selectedUserIds: string[]) => void
  onClose: () => void
}

@observer
export default class AllowedUsersPicker extends React.Component<IProps> {
  private selectedUserIds: string[] = []

  public constructor(props: IProps) {
    super(props)

    this.selectedUserIds = props.appliedUsers.map(u => u.id)
    makeObservable(this)
  }

  public render() {
    const { appliedUsers, onClose } = this.props

    return (
      <UsersDirectory
        shouldUseAllProjectMembers
        isSelectionMode
        shouldSelectOnlyUsers
        selectedUsers={appliedUsers}
        onItemSelect={this.selectUser}
        onHeaderCloseClick={onClose}
        applyButton={
          <Button variant="default" onClick={this.handleApply}>
            {Localization.translator.apply}
          </Button>
        }
      />
    )
  }

  public selectUser = (userTags: ITag[]) => {
    this.selectedUserIds = userTags.map(ut => ut.id)
  }

  @action.bound
  private handleApply() {
    this.props.onApply(this.selectedUserIds)
  }
}
